// The "العربية" switch label on English pages: drawn with the device's own
// fonts so it does not pull the 160 KB Noto Sans Arabic web font onto every
// English page (the brand stack lists Noto Sans Arabic for Arabic glyphs).
// Arabic pages still use the brand fonts for all their text.
export const SYSTEM_FONT_STACK = "system-ui, -apple-system, 'Segoe UI', Tahoma, sans-serif";

/** Inline style for the language-switch label (only while the page is English). */
export const languageLabelStyle = (language) => (language === 'en' ? { fontFamily: SYSTEM_FONT_STACK } : undefined);
